import { render, staticRenderFns } from "./ManufacturerTab.vue?vue&type=template&id=27a10372&"
import script from "./ManufacturerTab.vue?vue&type=script&lang=ts&"
export * from "./ManufacturerTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports